import clsx from 'clsx';
import React from 'react';

interface SearchProps {
  disabled?: boolean;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const Search: React.FC<SearchProps> = ({
  disabled,
  value,
  onChange,
  placeholder = 'Search',
}) => {
  const clearValue = () => {
    onChange('');
  };

  return (
    <div className="h-10 w-full flex-col justify-start items-start inline-flex">
      <div className="h-10 w-full flex-col justify-start items-start gap-1 flex">
        <div className="self-stretch h-10 flex items-center gap-2 relative">
          <i className="ri-search-line text-[20px] absolute left-3 text-navy-400" />
          <input
            className={clsx(
              'w-full h-full pr-10 pl-10 py-2 bg-white rounded border text-primary placeholder:text-navy-400 text-body2',
              'disabled:bg-grey-100 disabled:text-grey-300 disabled:placeholder-grey-300 disabled:border-grey-100',
              'border-navy-200 outline-primary',
              'focus:outline-1'
            )}
            disabled={disabled}
            placeholder="Search"
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
          />
          {value && !disabled && (
            <i
              className={clsx(
                'text-[20px] absolute right-3',
                'ri-close-circle-line text-navy-400 cursor-pointer',
                disabled && '!text-grey-300'
              )}
              role="presentation"
              onClick={clearValue}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Search;
